<template>
	<Popup
		v-model="showPolicyPopup"
		width="1200"
	>
		<div v-html="$t('popupPolicyHtml')"></div>
	</Popup>
</template>

<script>
import Popup from '@/components/Popup'

export default {
	components: {
		Popup,
	},

	computed: {
		showPolicyPopup: {
			get() {
				return this.$store.state.general.popups.policyPopup
			},
			set(show) {
				this.$store.dispatch('general/togglePopup', {
					name: 'policyPopup',
					show,
				})
			},
		},
	},
}
</script>
